import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { allCourses } from "../../service/endpoints";

export const CourseHandler = createAsyncThunk('CourseHandler', async (data) => {
  try {
    const response = await allCourses(data);

    console.log(response.data, '+++++++++++++++++++++++++++');
    return response.data;

  } catch (error) {
    if (error.response !== undefined) {
      console.log('fail', error);
      throw error.response;
    } else
    {
      console.log(error);
      throw error.response;
    }
  }
});


const CourseSlice = createSlice({
  name: 'get_course',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: (builder) => {
    builder.addCase(CourseHandler.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(CourseHandler.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(CourseHandler.rejected, (state, action) => {
      console.log(action.state);
      state.isError = true;
      console.log(action.payload);

    });
  }

});

export default CourseSlice.reducer;